import React, { useState, Children, memo } from 'react'
import { TabNamesWrapper, TabName, TabNameButton, TabWrapper } from './style'

const TabsWrapper = memo(props => {
  const { currentIndex, tabs } = props
  return (
    <div>
      {Children.map(tabs, (child, i) => {
        const isVisible = Number(i) === Number(currentIndex) ? 'block' : 'none'
        return (
          <div style={{ display: isVisible }}>
            {child}
          </div>
        )
        //{ ...child, activeIndex: currentIndex }
      })}
    </div>
  )
})

export const Tabs = props => {
  const { children, afterTabChange } = props
  const [ currentIndex, updateIndex ] = useState( 0 )

  const handleTabChange = index => {
    if( currentIndex === index )
      return
    
    updateIndex(index)
    if(afterTabChange){
      afterTabChange()
    }
  }

  return (
    <div>
      <TabNamesWrapper>
        {Object.keys(children).map( index => {
          const item = children[index]
          return (
            <TabName key={index}>
              <TabNameButton 
                index={index}
                currentIndex={currentIndex}
                onClick={() => handleTabChange(index)}>
                  {item.props.label}
              </TabNameButton>
            </TabName>
          )
        })}
      </TabNamesWrapper>
      <TabsWrapper currentIndex={currentIndex} tabs={children} />
    </div>
  )
}

export const Tab = memo(props => {
  const { children } = props

  return (
    <TabWrapper className="tab">{children}</TabWrapper>
  )
})